import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'abbreviateNumber',
    standalone: false
})
export class AbbreviateNumberPipe implements PipeTransform {

  transform(value: number | string, ...args: unknown[]): string {
    const numValue = parseFloat(value.toString());
    const formattedNumber = new Intl.NumberFormat('en-US', {
      notation: 'compact',
      compactDisplay: 'short'
    }).format(Math.floor(numValue));
    return formattedNumber;
  }

}
